import { TakeoverCartEntry, doesCartContainTakeoverTarget } from '../cart-targeting';

import { AppTakeoverType, useAppTakeover } from './use-app-takeover';

type AppTakeoverOrderConfirmationResult = Partial<
  NonNullable<AppTakeoverType['orderConfirmDetails']> & { isTakeoverActive: boolean }
>;

export const useAppTakeoverOrderConfirmation = (
  cartEntries: readonly TakeoverCartEntry[] | null | undefined
): AppTakeoverOrderConfirmationResult => {
  const appTakeover = useAppTakeover();
  const isCartEligible = doesCartContainTakeoverTarget(
    cartEntries,
    appTakeover.pdp?.targetMenuItemIds
  );

  if (!isCartEligible || !appTakeover.orderConfirmDetails) {
    return { isTakeoverActive: false };
  }

  return { ...appTakeover.orderConfirmDetails, isTakeoverActive: true };
};
